import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2, Save } from "lucide-react";
import api from "@/lib/api";
import ChessBoard from "@/components/ChessBoard";

const inp = "rounded-lg bg-chessup-deep border border-chessup-border px-3 py-2 text-sm text-chessup-text focus:border-chessup-turq focus:outline-none w-full";
const THEMES = ["Mate em 1", "Mate em 2", "Garfo", "Cravada", "Ataque duplo", "Ataque descoberto", "Defesa", "Finais"];
const DIFF = ["Fácil", "Médio", "Difícil"];
const LEVELS = [["pawn", "Peão"], ["knight", "Cavalo"], ["bishop", "Bispo"], ["rook", "Torre"], ["queen", "Dama"], ["king", "Rei"]];
const EMPTY = { title: "Novo puzzle", instruction: "Encontre o melhor lance.", fen: "6k1/5ppp/8/8/8/8/5PPP/R5K1 w - - 0 1", correct_moves: [], hint: "", explanation: "", theme: "Mate em 1", difficulty: "Fácil", xp: 10, level_key: "pawn", published: true };

export default function AdminPuzzles() {
  const [puzzles, setPuzzles] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = () => api.get("/admin/puzzles").then(({ data }) => setPuzzles(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (editing.id) await api.put(`/admin/puzzles/${editing.id}`, editing);
    else await api.post("/admin/puzzles", editing);
    toast.success("Puzzle salvo"); setEditing(null); load();
  };
  const del = async (id) => { if (!window.confirm("Excluir puzzle?")) return; await api.delete(`/admin/puzzles/${id}`); load(); };

  return (
    <div className="p-5 sm:p-8 max-w-4xl">
      <div className="flex items-center justify-between mb-6">
        <h1 className="font-heading text-3xl text-chessup-text">Puzzles</h1>
        <button onClick={() => setEditing({ ...EMPTY })} data-testid="admin-create-puzzle" className="inline-flex items-center gap-1.5 rounded-full bg-chessup-gold px-4 py-2 text-sm font-semibold text-chessup-deep"><Plus className="h-4 w-4" /> Novo puzzle</button>
      </div>

      {editing ? (
        <div className="rounded-xl border border-chessup-border bg-chessup-card p-5 grid lg:grid-cols-2 gap-6">
          <div className="space-y-3">
            <input className={inp} value={editing.title} onChange={(e) => setEditing({ ...editing, title: e.target.value })} placeholder="Título" />
            <input className={inp} value={editing.instruction} onChange={(e) => setEditing({ ...editing, instruction: e.target.value })} placeholder="Instrução" />
            <input className={inp} value={editing.fen} onChange={(e) => setEditing({ ...editing, fen: e.target.value })} placeholder="FEN inicial" />
            <input className={inp} value={(editing.correct_moves || []).join(",")} onChange={(e) => setEditing({ ...editing, correct_moves: e.target.value.split(",").map((s) => s.trim().toLowerCase()).filter(Boolean) })} placeholder="Lances corretos (ex: a1a8)" />
            <input className={inp} value={editing.hint} onChange={(e) => setEditing({ ...editing, hint: e.target.value })} placeholder="Dica" />
            <textarea className={inp} rows={2} value={editing.explanation} onChange={(e) => setEditing({ ...editing, explanation: e.target.value })} placeholder="Explicação" />
            <div className="grid grid-cols-2 gap-3">
              <select className={inp} value={editing.theme} onChange={(e) => setEditing({ ...editing, theme: e.target.value })}>{THEMES.map((t) => <option key={t}>{t}</option>)}</select>
              <select className={inp} value={editing.difficulty} onChange={(e) => setEditing({ ...editing, difficulty: e.target.value })}>{DIFF.map((d) => <option key={d}>{d}</option>)}</select>
              <select className={inp} value={editing.level_key} onChange={(e) => setEditing({ ...editing, level_key: e.target.value })}>{LEVELS.map(([k, n]) => <option key={k} value={k}>{n}</option>)}</select>
              <input type="number" className={inp} value={editing.xp} onChange={(e) => setEditing({ ...editing, xp: parseInt(e.target.value) || 0 })} placeholder="XP" />
            </div>
            <label className="flex items-center gap-1.5 text-sm text-chessup-subtext"><input type="checkbox" checked={!!editing.published} onChange={(e) => setEditing({ ...editing, published: e.target.checked })} /> Publicado</label>
            <div className="flex gap-2">
              <button onClick={save} data-testid="admin-save-puzzle" className="inline-flex items-center gap-1.5 rounded-full bg-chessup-gold px-5 py-2.5 text-sm font-semibold text-chessup-deep"><Save className="h-4 w-4" /> Salvar</button>
              <button onClick={() => setEditing(null)} className="rounded-full border border-chessup-border px-5 py-2.5 text-sm text-chessup-text">Cancelar</button>
            </div>
          </div>
          <div>
            <div className="text-xs text-chessup-subtext mb-2">Pré-visualização da posição</div>
            <ChessBoard fen={editing.fen} interactive={false} orientation={editing.fen.split(" ")[1] === "b" ? "black" : "white"} resetKey={editing.fen} />
          </div>
        </div>
      ) : (
        <div className="space-y-2">
          {puzzles.map((p) => (
            <div key={p.id} className="flex items-center gap-3 rounded-lg border border-chessup-border bg-chessup-card px-4 py-3">
              <div className="flex-1"><div className="text-sm text-chessup-text">{p.title}</div><div className="text-xs text-chessup-subtext">{p.theme} · {p.difficulty} · {p.xp} XP</div></div>
              <button onClick={() => setEditing(p)} className="rounded-lg bg-chessup-turq/15 text-chessup-turq px-3 py-1.5 text-sm">Editar</button>
              <button onClick={() => del(p.id)} className="rounded-lg bg-destructive/15 text-red-200 px-3 py-1.5"><Trash2 className="h-4 w-4" /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
